import React from 'react';
import { twMerge } from 'tailwind-merge';

import type { FaqItem as FaqItemType } from '../types';
import { FaqItem } from './FaqItem';

interface FaqSectionProps {
  faqData: FaqItemType[] | null;
  openIndexes: Set<number>;
  onToggle: (index: number) => void;
  title?: string;
  titleClassName?: string;
  questionClassName?: string;
}

/**
 * FAQ section containing all FAQ items
 */
export const FaqSection: React.FC<FaqSectionProps> = ({
  faqData,
  openIndexes,
  onToggle,
  title = 'FAQ',
  titleClassName = '',
  questionClassName = '',
}) => {
  if (!faqData || faqData.length === 0) return null;

  return (
    <div className="space-y-4">
      <h2
        className={twMerge(
          'mb-6 font-neutrifb text-lg sm:text-3xl',
          titleClassName,
        )}
      >
        {title}
      </h2>
      <div className="space-y-3">
        {faqData.map((item, index) => (
          <FaqItem
            questionClassName={questionClassName}
            key={index}
            item={item}
            index={index}
            isOpen={openIndexes.has(index)}
            onToggle={onToggle}
          />
        ))}
      </div>
    </div>
  );
};
